import { render, staticRenderFns } from "./matchDEtail.vue?vue&type=template&id=36dcff84&scoped=true&"
import script from "./matchDEtail.vue?vue&type=script&lang=js&"
export * from "./matchDEtail.vue?vue&type=script&lang=js&"
import style0 from "./matchDEtail.vue?vue&type=style&index=0&id=36dcff84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dcff84",
  null
  
)

export default component.exports